module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 13.c167e567.png";